import React from 'react';
import MainPageComponent from '../components/mainPageComponent/mainPageComponent';

export default function Main() {


    return <MainPageComponent />;
}